// src/Pages/Optical/Optical.js
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { OpticalForm } from "./OpticalForm";


const Optical = ({ formUserData, setFormUserData, onSaveDetails, onDeleteLogo, onClose ,kc, theme }) => {

    const { t } = useTranslation();
    return (
        <div className='px-4 md:px-8'>
            <h1 className="text-xl sm:text-3xl uppercase py-3 sm:py-4">{t('Optical Data')}</h1>
            <OpticalForm formUserData={formUserData} setFormUserData={setFormUserData} onDeleteLogo={onDeleteLogo}  onSaveDetails={onSaveDetails} onClose={onClose} kc={kc}/>
        </div>
    );
}


export default Optical;
